/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux';
import authReducer from './authReducer';
import entities from './entities';

export default history =>
    combineReducers({
        authReducer,
        entities,
    });